import { Error } from '../error';

export const Page403 = () => (
  <Error errorTitle="403" errorMessage="Forbidden response status code indicates that the server understands the request but refuses to authorize it." />
);
